import React from 'react'
import PropTypes from 'prop-types'
import { Radio } from 'antd'
import { classNames } from 'utils/utils'
import InputLabel from 'components/patterns/Inputs/InputLabel'

import 'styles/AntOverrides.css'
import 'styles/ChecComponents.css'

const RadioButtonGroup = ({
  currentValue,
  buttonStyle,
  size,
  onChange,
  disabled,
  buttons,
  style,
  className,
  label,
  vertical,
  hint,
  tooltip,
  required,
}) => (
  <div className={classNames('form-field', className)}>
    {label && (
      <InputLabel
        label={label}
        hint={hint}
        tooltip={tooltip}
        required={required}
        size={size}
        vertical={vertical}
      />
    )}
    <Radio.Group
      className={'chec-radio-group'}
      style={style}
      value={currentValue}
      buttonStyle={buttonStyle}
      size={size}
      onChange={onChange}
      disabled={disabled}
    >
      {buttons.map(
        ({ value, text = '', image, buttonClass, disabled }, index) => (
          <Radio.Button
            key={`${value}${text}${index}`}
            value={value}
            className={`${buttonClass || ''} chec-radio-button`}
            disabled={disabled}
          >
            {image || text || value}
          </Radio.Button>
        )
      )}
    </Radio.Group>
  </div>
)

RadioButtonGroup.defaultProps = {
  size: 'default',
  buttonStyle: 'solid',
  disabled: false,
  vertical: false,
}

RadioButtonGroup.propTypes = {
  className: PropTypes.string,
  currentValue: PropTypes.string.isRequired,
  buttonStyle: PropTypes.oneOf(['outline', 'solid']),
  size: PropTypes.oneOf(['large', 'default', 'small']),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      text: PropTypes.string,
      disabled: PropTypes.bool,
      image: PropTypes.node,
    })
  ).isRequired,
  style: PropTypes.object,
  label: PropTypes.string,
  image: PropTypes.node,
  vertical: PropTypes.bool,
  hint: PropTypes.string,
  tooltip: PropTypes.string,
  required: PropTypes.bool,
}

export default RadioButtonGroup
